import Vue from 'vue'
import Router from 'vue-router'

// import Layout from '@/supp'

Vue.use(Router)
export const constantRoutes = [
  {
    path: '/',
    redirect: '/support/MR08',
  },
  {
    path: '/ai',
    component: () => import('@/views/ai/Index'),
  },
  {
    path: '/article/:title',
    component: () => import('@/views/support/Detail'),
  },
  {
    path: '/article/:title/:lang',
    component: () => import('@/views/support/Detail'),
  },
  {
    path: '/support',
    component: () => import('@/views/support/Index'),
    hidden: true,
    children: [
      {
        name: 'SupportDetail',
        path: '/support/:title',
        component: () => import('@/views/support/Detail')
      }
    ]
  }
]
/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {
  }
]
export const errorRoutes = [
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  mode: 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
